import { Phone } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "@/lib/api";

export const StickyCallBar = () => {
  return (
    <a
      href={`tel:${PHONE_TEL}`}
      className="fixed bottom-0 left-0 right-0 z-40 bg-red-600 text-white py-4 flex items-center justify-center gap-2 font-semibold text-base border-t border-red-700 shadow-2xl md:hidden active:bg-red-700"
      data-testid="sticky-call-bar"
    >
      <Phone size={20} /> Call {PHONE_DISPLAY}
    </a>
  );
};
